module.exports = __webpack_public_path__ + "img/tab_02.6ca83517.jpg";